<template>
  <div>
    <!-- todo - https://stackoverflow.com/questions/50392918/vuetify-how-to-preselect-active-tab
     -->
    <v-tabs
      v-if="!isPrintScreen"
      v-model="activetab"
      align-with-title
    >
      <v-tab  v-for="tab of tabs"  :key="tab.id" @click="WarnUser(tab.to)">
        <span>{{ tab.caption }}</span>
      </v-tab>
    </v-tabs>
    <router-view />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { canAccessTreasurerChecks } from '../util/shared/treasurerChecksAccess';

const TREASURERS_CHECKS_TAB_ID = 6;

const GL_TABS = [
  { id: 1, to: { path: '/gl/transactions' }, caption: 'General Ledger' },
  { id: 2, to: { path: '/gl/browse/headings' }, caption: 'Browse' },
  { id: 3, to: { path: '/gl/sai/transactions' }, caption: 'Sa&i' },
  { id: 4, to: { path: '/gl/utils/bankReconciliation/reconTransaction' }, caption: 'Utils' },
  { id: 5, to: { path: '/gl/investments/investment' }, caption: 'Investments' },
  {
    id: TREASURERS_CHECKS_TAB_ID,
    to: { path: '/gl/treasurers-checks/checks' },
    caption: 'Treasurers Checks',
  },
];

/* partial path → tab id, for routes which are not a tab's own path */
const PARTIAL_PATH_TAB_IDS = [
  { match: 'browse', id: 2 },
  { match: 'utils', id: 4 },
  { match: 'treasurers-checks', id: TREASURERS_CHECKS_TAB_ID },
];

export default {
  name: 'GeneralLedger',
  components: {
  },
  data: () => ({
    dialog: false,
    path: '',
    activetab: 0,
  }),
  created() {
    this.loadFiscalRegYears();
    /* drives the Treasurers Checks tab visibility */
    this.loadConfig({ requiredScope: 'glConfig' });
    this.getPathName();
  },
  updated() {
    this.getPathName();
  },
  watch: {
    /* glConfig arrives async — re-sync the selection once the tab list settles */
    tabs() {
      this.getPathName();
    },
  },
  methods: {
    ...mapActions('glDaily/glDailyTransaction', [
      'loadFiscalRegYears',
    ]),
    ...mapActions('SystemConfig', [
      'loadConfig',
    ]),
    /* index within the visible tabs, so hidden tabs don't shift the selection */
    tabIndexById(tabId) {
      return this.tabs.findIndex((tab) => tab.id === tabId);
    },
    getPathName() {
      const curPath = this.$route.path;
      const ftr = this.tabs.filter((ft) => ft.to.path === curPath);
      if (ftr.length > 0) {
        const matchedIndex = this.tabIndexById(ftr[0].id);
        this.activetab = matchedIndex >= 0 ? matchedIndex : 0;
        return;
      }
      const partial = PARTIAL_PATH_TAB_IDS.find((entry) => curPath.includes(entry.match));
      if (partial) {
        const partialIndex = this.tabIndexById(partial.id);
        if (partialIndex >= 0) this.activetab = partialIndex;
      }
    },
    WarnUser(path) {
      this.path = path;
      const currentpath = this.$router.currentRoute.path;
      if (path.path !== currentpath) {
        this.$router.push(path);
      }
    },
  },
  computed: {
    ...mapState({
      isPrintScreen: (state) => state.isPrintScreen,
      glSettingItem: (state) => state.SystemConfig.glSettingItem || {},
    }),
    tabs() {
      if (canAccessTreasurerChecks(this.glSettingItem)) return GL_TABS;
      return GL_TABS.filter((tab) => tab.id !== TREASURERS_CHECKS_TAB_ID);
    },
  },
};
</script>
